//medidad Banner 650x360px
export const ultimasNoticias = [
       {
        "imagen" :"../assets/imgs/Convocatorias/2026/Oferta academica 2026.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/1.-Convocatoria nuevo ingreso y oferta.pdf",
        "titulo" : "Oferta Academica 2026",
        "fecha" : "del 19 de enero al 30 de enero"
    },
       {
        "imagen" :"../assets/imgs/Convocatorias/2025/seleccionados PFAG-CAH.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/seleccionados PFAG-CAH.png",
        "titulo" : "Proyectos Seleccionados Programa de Formación y Produción en Artes Gráficas del Centro de las Artes de Hidalgo, 2025",
        "fecha" : "Resultados"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2025/taller aguafuerte CONVOCATORIA 3.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria%20%20Taller%20Aguafuente.pdf",
        "titulo" : "Selección de Proyectos para la Producción de Artes Gráficas",
        "fecha" : "24 de noviembre al 10 de diciembre del 2025"
    },

   {
        "imagen" :"../assets/imgs/Convocatorias/2025/Convocatoria03.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria Programa de Apoyo para el Fortalecimiento de Actividades Artisticas y Culturales 2025.pdf",
        "titulo" : "Resultados del Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2025 Segunda Etapa",
        "fecha" : "18 de junio del 2025"
    },
    
   {
        "imagen" :"../assets/imgs/Convocatorias/2025/Convocatoria02.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/Convocatorias/Convocatoria Programa para la Administración de Bienes, Servicios y Financiamiento a la Cultura del Ejercicio Fiscal 2025.pdf",
        "titulo" : "Resultados del Programa de Desarrollo Cultural Infantil Alas y Raíces Hidalgo 2025 Primer Etapa",
        "fecha" : "19 de Mayo del 2025"
    },
    
]